import { RemoteConstants } from "../../../data/remote/RemoteConstants";
import { UIActions } from "../../../presentation/redux/actions/UIActions";

// Función que envía el token de reCAPTCHA al servidor para su verificación y ejecuta la acción proporcionada.
export const verifyReCaptcha = async (token, setMessage, action, dispatch, resetCaptcha) => {
  // if (window.location.hostname === "localhost") {
  //   //Bypassing reCAPTCHA on localhost
  //   action();
  //   dispatch(UIActions.uiLoadInactive());
  //   return;
  // }
  const params = new URLSearchParams({
    recaptchaToken: token,
  });
  try {
    const verifyResponse = await fetch(`${RemoteConstants.BASE_URL}pos/verify/turnstile?${params.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!verifyResponse.ok) {
      throw new Error(`HTTP error! status: ${verifyResponse.status}`);
    }

    const result = await verifyResponse.json();

    if (result.code === "OK") {
      action();
    } else if (result.code === "FAILED") {
      setMessage("La verificación del CAPTCHA ha fallado. Por favor, actualiza la página e inténtalo de nuevo.");
      resetCaptcha?.();
    } else {
      setMessage("Error en la verificación del CAPTCHA. Código: " + result.code);
      resetCaptcha?.();
    }
  } catch (error) {
    console.error("Error en verifyReCaptcha:", error);
    setMessage("Error de conexión durante la verificación del CAPTCHA. Por favor, intenta nuevamente.");
    resetCaptcha?.();
  } finally {
    dispatch(UIActions.uiLoadInactive());
  }
};